"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreetAddress = void 0;
const Field_type_1 = require("../../../types/Field.type");
const utils_1 = require("../../../types/utils");
exports.StreetAddress = {
    priority: 40,
    label: 'fields.common.address.street_address.label',
    fallbackLabel: 'Address',
    mandatory: (payload, path) => true,
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isApplicable(payload, path) {
    const EXCLUDED_FLOWS = ['UPSELL_WEBSTORE_TO_KPOS', 'UPSELL_WEBSTORE_TO_ADS_MANAGER', 'MOR_ONBOARDING_GROUP', 'MOR_ONBOARDING_ENTITY'];
    const contractOnboardingTypeValue = payload.contract_onboarding_type?.valueOf?.();
    const isExcludedFlow = contractOnboardingTypeValue && EXCLUDED_FLOWS.includes(contractOnboardingTypeValue);
    const productChannelValue = (0, utils_1.getValueByPath)(payload, 'business_information.product_channel')?.valueOf?.();
    const isProductChannelInStore = productChannelValue === 'IN_STORE';
    const isInStorePath = path === 'in_stores.address.street_address';
    return !isExcludedFlow || (isProductChannelInStore && isInStorePath);
}
